import { ContextStore } from 'bernie-core';
import { getBexApiContext } from 'bernie-context';

import { getDateRangeInput, getDestinationInput, getRooms } from 'stores/adapters';
import { SearchCriteriaModel } from 'stores/models';

import { DatePickerContent, HotelViewModel, RateCalendarModel } from 'models';

import { classNames } from 'uitk-react-utils';

import { DestinationInput, OperationResult, PropertyRateCalendar, ShoppingContextInput } from '__generated__/api';

import PropertyCalendarRates = PropertyRateCalendar.PropertyCalendarRates;

const MIN_PROPERTIES_THRESHOLD = 25;

export const getPropertySearchResultsVariables = (
  context: ContextStore,
  searchCriteria: SearchCriteriaModel,
  properties: HotelViewModel[],
  shoppingContext: ShoppingContextInput
): PropertyRateCalendar.Variables => {
  const dateRange = getDateRangeInput(searchCriteria);
  const rooms = getRooms(searchCriteria);
  const destination = getDestinationInputWithPropertyIds(searchCriteria, properties);

  if (destination.propertyIds.length < MIN_PROPERTIES_THRESHOLD) {
    throw new Error('Not enough property ids to make request');
  }

  return {
    context: getBexApiContext(context),
    destination,
    criteria: {
      primary: {
        dateRange,
        destination,
        rooms,
      },
    },
    shoppingContext,
  };
};

export const adaptQueryToRateCalendarModel = (query: OperationResult<PropertyRateCalendar.Query>): RateCalendarModel => ({
  disclaimer: query.data.propertySearch.rateCalendar.disclaimer.value,
  footerHtml: query.data.propertySearch.rateCalendar.legend,
  datePickerContent: transformToDatePickerContent(query.data.propertySearch.rateCalendar.propertyCalendarRates),
});

const transformToDatePickerContent = (rates: PropertyCalendarRates[]) =>
  rates.reduce((content: DatePickerContent, model: PropertyCalendarRates) => {
    content[model.date.isoFormat] = {
      text: determineDatePickerContentTextFromPriceTrend(model.displayPrice),
      className: classNames(`price-trending ${model.displayPrice}`),
      ariaLabel: model.accessibilityLabel,
    };

    return content;
  }, {})!;

const determineDatePickerContentTextFromPriceTrend = (trend: string): string => (trend === 'negative' ? '▼' : '▲');

const getDestinationInputWithPropertyIds = (searchCriteria: SearchCriteriaModel, properties: HotelViewModel[]): DestinationInput => {
  const destination = getDestinationInput(searchCriteria);

  return {
    ...destination,
    propertyIds: properties.slice(0, MIN_PROPERTIES_THRESHOLD).map(it => it.id.toString()),
  };
};
